import { render, staticRenderFns } from "./Public.vue?vue&type=template&id=d60be21e&"
var script = {}
import style0 from "./Public.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports